<script lang="ts">
  import { tick } from 'svelte';
  import type { DataStore } from '../data/store';
  import type { SearchableTransaction } from '../data/types';
  import { formatCents, formatDate, signedClass } from '../presentation/format';
  import Button from '../ui/Button.svelte';
  import Icon from '../ui/Icon.svelte';

  let {
    transaction,
    store,
    close,
  }: { transaction: SearchableTransaction; store: DataStore; close: () => void } = $props();
  let closeButton = $state<HTMLButtonElement>();
  let copied = $state(false);

  $effect(() => {
    document.documentElement.classList.add('overlay-open');
    void tick().then(() => closeButton?.focus());
    return () => document.documentElement.classList.remove('overlay-open');
  });

  async function copyId(): Promise<void> {
    await navigator.clipboard.writeText(transaction.id);
    copied = true;
    setTimeout(() => (copied = false), 1600);
  }

  function keydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') close();
  }
</script>

<svelte:window onkeydown={keydown} />
<div
  class="overlay detail-overlay"
  role="presentation"
  onclick={(event) => event.target === event.currentTarget && close()}
>
  <div
    class="transaction-detail"
    role="dialog"
    aria-modal="true"
    aria-labelledby="transaction-detail-title"
  >
    <header class="sheet-header">
      <div>
        <p class="eyebrow">Dettaglio movimento</p>
        <h2 id="transaction-detail-title">{transaction.description ?? 'Senza descrizione'}</h2>
      </div>
      <button
        bind:this={closeButton}
        class="icon-button"
        type="button"
        aria-label="Chiudi dettaglio"
        onclick={close}><Icon name="close" /></button
      >
    </header>
    <div class="detail-body">
      <p class="detail-amount {signedClass(transaction.amount_cents)}">
        {formatCents(transaction.amount_cents)}
      </p>
      <dl>
        <div>
          <dt>Data</dt>
          <dd>{formatDate(transaction.date)}</dd>
        </div>
        <div>
          <dt>Tipo</dt>
          <dd>{transaction.type.replace('_', ' ')}</dd>
        </div>
        <div>
          <dt>Conto</dt>
          <dd>{store.accountLabel(transaction.account_id)}</dd>
        </div>
        <div>
          <dt>Gruppo</dt>
          <dd>{store.groupLabel(transaction.account_group_id)}</dd>
        </div>
        <div>
          <dt>Categoria</dt>
          <dd>{store.categoryLabel(transaction.category_id)}</dd>
        </div>
        <div>
          <dt>Controconto</dt>
          <dd>
            {transaction.counter_account_id
              ? store.accountLabel(transaction.counter_account_id)
              : '—'}
          </dd>
        </div>
        <div>
          <dt>ID transazione</dt>
          <dd class="wrap-id">{transaction.id}</dd>
        </div>
        <div>
          <dt>ID trasferimento</dt>
          <dd class="wrap-id">{transaction.transfer_id ?? '—'}</dd>
        </div>
      </dl>
    </div>
    <footer class="sheet-actions">
      <Button onclick={copyId}>{copied ? 'Copiato' : 'Copia ID'}</Button><Button
        variant="primary"
        onclick={close}>Chiudi</Button
      >
    </footer>
  </div>
</div>
